import React, { Component } from 'react'
import { Button, Input, Select } from 'antd'

const { Option } = Select

// Bộ lọc chung: SKU thêu, Partner thêu, Barcode item / Lô, Xoá lọc (FR-005)
class EmbroideryFilterBar extends Component {
    state = { q: this.props.filters.q }

    componentDidUpdate(prevProps) {
        // "Xoá lọc" hoặc chọn "Quá hạn công đoạn" đã xoá ô tìm từ bên ngoài
        if (prevProps.filters.q !== this.props.filters.q && this.props.filters.q !== this.state.q) {
            this.setState({ q: this.props.filters.q })
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timer)
    }

    _onChangeQ = (event) => {
        const q = event.target.value
        this.setState({ q })
        clearTimeout(this.timer)
        this.timer = setTimeout(() => this.props.onChange({ q: q.trim() }), 400)
    }

    render() {
        const { filters, skuOptions, partnerOptions, onChange, onClear, disabled } = this.props

        return (
            <div className='EmbroideryFilterBar'>
                <div className='field'>
                    <label>SKU thêu</label>
                    <Select
                        showSearch
                        allowClear
                        disabled={disabled}
                        placeholder='Tất cả SKU'
                        value={filters.sku || undefined}
                        onChange={(value) => onChange({ sku: value || '' })}
                    >
                        {skuOptions.map((sku) => <Option key={sku} value={sku}>{sku}</Option>)}
                    </Select>
                </div>
                <div className='field'>
                    <label>Partner thêu</label>
                    <Select
                        allowClear
                        disabled={disabled}
                        placeholder='Tất cả partner'
                        value={filters.partner || undefined}
                        onChange={(value) => onChange({ partner: value || '' })}
                    >
                        {partnerOptions.map((p) => <Option key={p.value} value={p.value}>{p.label}</Option>)}
                    </Select>
                </div>
                <div className='field'>
                    <label>Barcode item / Lô</label>
                    <Input
                        allowClear
                        placeholder='vd 10231187_2 hoặc Y-64612'
                        value={this.state.q}
                        onChange={this._onChangeQ}
                    />
                </div>
                <Button icon='close' className='clearBtn' disabled={disabled} onClick={onClear}>Xoá lọc</Button>
            </div>
        )
    }
}

EmbroideryFilterBar.defaultProps = { skuOptions: [], partnerOptions: [], disabled: false }

export default EmbroideryFilterBar
